import React, { useState } from 'react';
import '../css/ScrollButton.css';

function ScrollButton({ direction }) {

    const [hovered, setHovered] = useState(false);

    const handleScroll = () => {

        if (direction === 'top') {

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

        } else {

            window.scrollTo({
                top: document.documentElement.scrollHeight,
                behavior: 'smooth'
            });

        }

    };

    return (

        <div
            className={`esc-scroll-container esc-scroll-${direction}`}
        >

            <button
                className={`esc-scroll-button ${hovered ? 'esc-hovered' : ''}`}
                onClick={handleScroll}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                aria-label={
                    direction === 'top'
                        ? 'Ir arriba'
                        : 'Ir abajo'
                }
            >

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="26"
                    height="26"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >

                    <circle
                        cx="12"
                        cy="12"
                        r="10"
                    />

                    {direction === 'top' ? (

                        <>
                            <polyline points="16 12 12 8 8 12"></polyline>
                            <line x1="12" y1="16" x2="12" y2="8"></line>
                        </>

                    ) : (

                        <>
                            <polyline points="8 12 12 16 16 12"></polyline>
                            <line x1="12" y1="8" x2="12" y2="16"></line>
                        </>

                    )}

                </svg>

            </button>

        </div>

    );

}

export default ScrollButton;
